import { getLocale } from "../runtime";

const sv_iecountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ireland`
};

const iecountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_iecountryenglish(inputs)
	return "ieCountryEnglish";
};

export { iecountryenglish as "ieCountryEnglish" };